module.exports = __webpack_public_path__ + "img/horizontal_4_1_6005.bcdf2461.png";